const taxAccountSelector = (state) => state.taxAccount.taxAccounts

export { taxAccountSelector }
